import React from "react";

// Grafiki metod płatności: /public/img/pay/*.svg (znaki akceptacji na białych/firmowych kartach 120×76).
// Metody „via: stripe” muszą mieć odpowiednik w STRIPE_CHANNELS w backend/server.py.
export const PAYMENT_OPTIONS = [
  {
    id: "card",
    title: "Karta płatnicza",
    subtitle: "Visa, Mastercard — natychmiast",
    logos: ["/img/pay/visa.svg", "/img/pay/mastercard.svg"],
    via: "stripe",
    accent: "cyan",
    buttonLabel: "Zapłać kartą",
    note: "Płatność kartą Visa / Mastercard obsługuje bezpieczny system Stripe. Pliki otrzymasz natychmiast po opłaceniu.",
  },
  {
    id: "blik",
    title: "BLIK",
    subtitle: "Kod z aplikacji Twojego banku",
    logos: ["/img/pay/blik.svg"],
    via: "stripe",
    accent: "fuchsia",
    buttonLabel: "Zapłać BLIKIEM",
    note: "Płatność BLIKIEM obsługuje bezpieczny system Stripe. Pliki otrzymasz natychmiast po potwierdzeniu w aplikacji banku.",
  },
  {
    id: "wallet",
    title: "Apple Pay / Google Pay",
    subtitle: "Jednym dotknięciem w telefonie lub komputerze",
    logos: ["/img/pay/applepay.svg", "/img/pay/googlepay.svg"],
    via: "stripe",
    accent: "slate",
    buttonLabel: "Zapłać Apple Pay / Google Pay",
    note: "Przycisk Apple Pay lub Google Pay pojawi się na stronie płatności Stripe, jeśli Twoje urządzenie go obsługuje (w przeciwnym razie zapłacisz kartą). Pliki otrzymasz natychmiast po opłaceniu.",
  },
  {
    id: "revolut_pay",
    title: "Revolut Pay",
    subtitle: "Szybko z aplikacji Revolut",
    logos: ["/img/pay/revolut.svg"],
    via: "stripe",
    accent: "indigo",
    buttonLabel: "Zapłać Revolut Pay",
    note: "Płatność Revolut Pay obsługuje bezpieczny system Stripe — potwierdzasz ją w aplikacji Revolut. Pliki otrzymasz natychmiast po opłaceniu.",
  },
  {
    id: "klarna",
    title: "Klarna",
    subtitle: "Kup teraz, zapłać później lub w ratach",
    logos: ["/img/pay/klarna.svg"],
    via: "stripe",
    accent: "pink",
    buttonLabel: "Zapłać z Klarna",
    note: "Płatność odroczoną lub ratalną udostępnia Klarna (umowę zawierasz z Klarna, po jej akceptacji). Pliki otrzymasz natychmiast po zatwierdzeniu płatności.",
  },
  {
    id: "transfer",
    title: "Przelew bankowy",
    subtitle: "Tradycyjny przelew na nasze konto",
    logos: ["/img/pay/transfer.svg"],
    via: "manual",
    accent: "teal",
    buttonLabel: "Zamawiam i płacę przelewem",
    note: "Po zaksięgowaniu przelewu wyślemy produkt e-mailem — natychmiast po otrzymaniu płatności na nasze konto.",
  },
];

export const ACCENTS = {
  cyan: "border-cyan-400/70 bg-cyan-500/10 shadow-[0_8px_24px_-8px_rgba(6,182,212,.5)]",
  fuchsia: "border-fuchsia-400/70 bg-fuchsia-500/10 shadow-[0_8px_24px_-8px_rgba(217,70,239,.45)]",
  slate: "border-slate-300/70 bg-slate-300/10 shadow-[0_8px_24px_-8px_rgba(203,213,225,.4)]",
  indigo: "border-indigo-400/70 bg-indigo-500/10 shadow-[0_8px_24px_-8px_rgba(99,102,241,.45)]",
  pink: "border-pink-300/70 bg-pink-400/10 shadow-[0_8px_24px_-8px_rgba(244,114,182,.45)]",
  teal: "border-teal-400/70 bg-teal-500/10 shadow-[0_8px_24px_-8px_rgba(45,212,191,.5)]",
};

// Pasek „Akceptujemy" — pod sumą w koszyku
export function PaymentLogoStrip({ className = "" }) {
  return (
    <div className={`flex flex-wrap items-center justify-center gap-1.5 ${className}`} data-testid="payment-logo-strip" aria-label="Akceptowane formy płatności">
      {PAYMENT_OPTIONS.flatMap((o) => o.logos.map((src) => ({ src, alt: o.title, key: o.id + src }))).map((l) => (
        <img key={l.key} src={l.src} alt={l.alt} loading="lazy" className="h-7 w-auto rounded-md shadow-md" />
      ))}
    </div>
  );
}
